<p>Download all firmware data across all assets. This can take a minute to generate.</p>
<div class="mb-3">
	<label>
		<input type="checkbox" [(ngModel)]="ignoreMyOrg">
		Ignore assets from {{api.user.organization_name}}
	</label>
</div>
<app-action-button [action]="DownloadFirmware" [context]="this" processing="Downloading..." complete="Downloaded" btnClass="green">Download CSV <i
		class="green leftpad icon-download"></i></app-action-button>